import React, { FC, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import {
  Row,
  Col,
  Input,
  Button,
  Select,
  DatePicker,
  Collapse,
  Slider,
  Checkbox,
} from "antd";
import { ReactSVG } from "react-svg";
import { SearchOutlined, DownOutlined } from "@ant-design/icons";
import _ from "lodash";
import { Form } from "antd";
import { useLocation } from "react-router-dom";
import {
  BioTopics,
  ExtendedBioTopics,
  ModalType,
  SocketTopics,
  UserTopics,
} from "constants/enums";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import GooglePlacesAutocomplete from "react-google-places-autocomplete";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import {
  SET_CURRENT_PROJECT,
  SET_SUBMITTED,
  ADD_OTHER_LOCATION,
  REMOVE_OTHER_LOCATION,
  SET_URL_PARAMS,
} from "reducers/reducer";
import { pushNotification } from "utils/notifications";
import moment from "moment";
import { QuestionaireType } from "../../../../constants/enums";
import NumberInput from "../../../../common/NumberInput";
import CurrencyInput from "../../../../common/CurrencyInput";
import FileUpload from "../../../../common/FileUpload";
import TagInput from "../../../../common/TagInput";
import DateInput from "../../../../common/DateInput";
import TimeInput from "../../../../common/TimeInput";
import YesNoInput from "../../../../common/YesNoInput";
import MultipleChoiceInput from "../../../../common/MultipleChoiceInput";
import ThreeButtonsInput from "../../../../common/ThreeButtonsInput";
import BarInput from "../../../../common/BarInput";
import LocationInput from "../../../../common/LocationExtendedInput";

import useSocketActions from "../../../../hooks/socketActions";
import {
  getUserPath,
  getUserRolesPath,
  getVehicleExtendedBioPath,
} from "../../../../hooks/socketConstants";

import useLocalStorage from "../../../../services/localStorage";
import { getParameterByName } from "../../../../common/helpers";

const { Option } = Select;

const { Panel } = Collapse;

const DispatchPanel: FC<{ socket: ISocket; params: any }> = ({
  socket,
  params,
}) => {
  const [nine11Form] = Form.useForm();
  const [error, setError] = useState<string>("");
  const { screens, setScreens } = params;
  const { search } = useLocation();
  const history = useHistory();

  const dispatch = useDispatch();
  const { projects, bio, rolesList, urlParams, survey } = useSelector(
    (state: RootState) => state.auth
  );
  const [searching, setSearching] = useState<boolean>(false);

  const [bioUrlParams, setBioUrlParams] = useState<
    | {
        adminId: string;
        userId: string;
        role: string;
        cudbServiceId: string;
        type: string;
      }
    | any
  >({});

  const selectBio = useRef<any>({
    basicBio: [],
    extendedBio: [],
  });
  const [userRoles, setUserRoles] = useState<any>([]);

  const { getLocalStorageItem, setLocalStorageItem } = useLocalStorage();

  const onSelectRole = (roleId) => {
    const extendedBio =
      rolesList.find((role) => role._id === roleId)?.extendedBio || [];

    const cols = extendedBio.map((bio) => {
      return {
        Cols: [
          {
            name: bio.name,
            label: bio?.label,
            type: bio.type,
            value: "",
            isMulti: bio.isMulti,
            options: bio.isMulti,
            ColSize: 24,
          },
        ],
      };
    });

    // need to ask
    selectBio.current = {
      basicBio: selectBio.current.basicBio,
      extendedBio: [],
    };
  };

  const Bio = [
    {
      Cols: [
        {
          name: "email",
          label: "Enter Email",
          type: QuestionaireType.Email,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 8,
        },
        {
          name: "phone",
          label: "Enter Phone Number",
          type: QuestionaireType.Phone,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 8,
        },
        {
          name: "customId",
          label: "Enter Custom ID",
          type: QuestionaireType.Text,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 8,
        },
      ],
    },
    {
      Cols: [
        {
          name: "beamIds",
          label: "Enter Beam ID",
          type: QuestionaireType.Text,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 8,
        },
        {
          name: "roleId",
          label: "Select Role",
          type: QuestionaireType.Search,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 8,
          onChange: onSelectRole,
        },
        {
          name: "doB",
          label: "Date of Birth",
          type: QuestionaireType.Date,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 8,
        },
      ],
    },
    {
      Cols: [
        {
          name: "firstName",
          label: "Enter First Name",
          type: QuestionaireType.Text,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 8,
        },
        {
          name: "middleName",
          label: "Enter Middle Name",
          type: QuestionaireType.Text,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 8,
        },
        {
          name: "lastName",
          label: "Enter last Name",
          type: QuestionaireType.Text,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 8,
        },
      ],
    },
    {
      Cols: [
        {
          name: "gender",
          label: "Select Gender",
          type: QuestionaireType.MultipleChoice,
          value: "",
          isMulti: false,
          options: ["male", "female"],
          ColSize: 4,
        },
        {
          name: "location",
          label: "Enter Location",
          type: QuestionaireType.Location,
          value: "",
          isMulti: false,
          options: [],
          ColSize: 20,
        },
      ],
    },
  ];
  const { getUserRequestPayload, updateUserRequestPayloadV2 } =
    useSocketActions();

  const RenderFields: FC<{
    data: any;
    name?: any;
    restFields?: any;
    onChange?: any;
  }> = ({ data, name, restFields, onChange }) => {
    const [mChoice, setMchoice] = useState("");
    const [value, setValue] = useState(data?.value || "");
    const [dateTime, setDateTime] = useState<any>("");
    const [time, setTime] = useState<any>("");

    useEffect(() => {
      if (data?.type === QuestionaireType.DateTime) {
        setDateTime(moment(data?.value));
      } else if (data?.type === QuestionaireType.Time) {
        setTime(moment(data?.value).format("hh:mm a"));
      }
    }, []);
    const sliderIndicatorStyle = {
      marginLeft: 10,
      fontSize: "medium",
    };
    const itemName = [name, data?.name];
    const [description, setDescription] = useState<any>(data?.value || "");

    let renderEle: any = "";
    switch (data.type) {
      case QuestionaireType.DropDown:
        break;
      case QuestionaireType.Text:
        renderEle = (
          <Form.Item name={itemName}>
            <Input
              defaultValue={description}
              value={description}
              placeholder={data?.label}
              onChange={(e) => {
                setDescription(e.target.value);
                onChange(e.target.value);
              }}
            />
          </Form.Item>
        );
        break;
      case QuestionaireType.YesNo:
        renderEle = (
          <Form.Item {...restFields} name={itemName}>
            <YesNoInput
              placeholder={data?.label}
              onChange={(value) => {
                onChange(value);
              }}
            />
          </Form.Item>
        );
        break;
      case QuestionaireType.ThreeButton:
        renderEle = (
          <Form.Item name={itemName}>
            <ThreeButtonsInput
              placeholder={data?.label}
              onChange={(value) => {
                onChange(value);
              }}
            />
          </Form.Item>
        );
        break;
      case QuestionaireType.Number:
        renderEle = (
          <div className="tiles padding-12">
            <span className="col-label">{data?.label}</span>
            <Row className="w-100 mt-2">
              <Col span={24}>
                <Form.Item name={itemName}>
                  <NumberInput
                    value={data.value}
                    onChange={(num) => {
                      onChange(num)
                      data.value = num;
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
        );
        break;
      case QuestionaireType.MultipleChoice:
        renderEle = (
          <Form.Item name={itemName}>
            <MultipleChoiceInput
              value={data?.value}
              options={data?.options}
              isMulti={data.isMulti}
              placeholder={data?.label}
              onChange={(option) => {
                onChange(option);
              }}
            />
          </Form.Item>
        );
        break;
      case QuestionaireType.Bar:
        renderEle = (
          <Form.Item name={itemName}>
            <BarInput
              value={data?.value}
              options={data?.options}
              placeholder={data?.label}
              onChange={(value) => {
                onChange(value);
              }}
            />
          </Form.Item>
        );
        break;
      case QuestionaireType.Date:
        renderEle = (
          <Row>
            <Col span={24}>
              <div className="datetime-item">
                <img src="/images/date.png" alt="" />
                <Form.Item name={itemName}>
                  <DateInput
                    placeholder={data?.label}
                    value={data?.value}
                    onChange={(value) => {
                      setDateTime(value);
                      onChange(value);
                    }}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
        );
        break;
      case QuestionaireType.DateTime:
        renderEle = (
          <Row className=" w-full mt-2">
            <div className="datetime-item">
              <img src="/images/date.png" alt="" />
              <DatePicker
                showTime
                placeholder={data?.label}
                suffixIcon={<DownOutlined />}
                value={dateTime}
                onChange={(datetime: moment.Moment | null) => {
                  onChange(datetime);
                }}
              />
            </div>
          </Row>
        );
        break;

      case QuestionaireType.Currency:
        renderEle = (
          <div className="tiles padding-12 mt-4">
            <span className="col-label">{data?.label}</span>
            <Row className="w-100 mt-2">
              <Col span={24}>
                <Form.Item name={itemName}>
                  <CurrencyInput
                    suffix={data.options[0]}
                    onChange={(value) => {
                      onChange(value);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
        );
        break;
      case QuestionaireType.Location:
        renderEle = (
          <Form.Item name={itemName}>
            <LocationInput
              placeholder={data?.label}
              value={data?.value || null}
              onChange={(value) => {
                onChange(value);
              }}
            />
          </Form.Item>
        );
        break;
      case QuestionaireType.GPS:
        renderEle = (
          <Form.Item name={itemName}>
            <LocationInput
              placeholder={data?.label}
              value={data?.value || null}
              onChange={(location) => {
                onChange(value);
              }}
            />
          </Form.Item>
        );
        break;
      case QuestionaireType.File:
        renderEle = (
          <Row>
            <Col span={24}>
              <Form.Item name={itemName}>
                <FileUpload placeholder={data?.label} onChange={(img) => {}} />
              </Form.Item>
            </Col>
          </Row>
        );
        break;
      case QuestionaireType.Signature:
        renderEle = (
          <Row>
            <Col span={24}>
              <Form.Item name={itemName}>
                <FileUpload placeholder={data?.label} onChange={(img) => {}} />
              </Form.Item>
            </Col>
          </Row>
        );
        break;
      case QuestionaireType.Media:
        renderEle = (
          <Row>
            <Col span={24}>
              <Form.Item name={itemName}>
                <FileUpload placeholder={data?.label} onChange={(img) => {}} />
              </Form.Item>
            </Col>
          </Row>
        );
        break;
      case QuestionaireType.Capture:
        renderEle = (
          <Row>
            <Col span={24}>
              <Form.Item name={itemName}>
                <FileUpload placeholder={data?.label} onChange={(img) => {}} />
              </Form.Item>
            </Col>
          </Row>
        );
        break;
      case QuestionaireType.Email:
        renderEle = (
          <Col span={24}>
            <Form.Item
              name={itemName}
              rules={[
                {
                  required: true,
                  message: "Email is required",
                },
                {
                  pattern:
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                  message:
                    "This field must be a valid email. Example: xyz@beam.live",
                },
              ]}
            >
              <Input
                defaultValue={data?.value}
                value={data?.value}
                placeholder={data?.label}
                onChange={(e) => {
                  data.value = e.target.value;
                }}
              />
            </Form.Item>
          </Col>
        );
        break;
      case QuestionaireType.Tag:
        renderEle = (
          <Form.Item name={itemName}>
            <TagInput
              placeholder={data?.label}
              onChange={(value) => {
                onChange(value);
              }}
            />
          </Form.Item>
        );
        break;
      case QuestionaireType.TagNot:
        renderEle = (
          <Form.Item name={itemName}>
            <TagInput
              placeholder={data?.label}
              onChange={(value) => {
                onChange(value);
              }}
            />
          </Form.Item>
        );
        break;
      case QuestionaireType.Phone:
        renderEle = (
          <Row className="d-flex">
            <Col span={24}>
              <Form.Item
                name={itemName}
                rules={[
                  {
                    required: true,
                    message: "Phone is required",
                  },
                  {
                    pattern:
                      /^[+][(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{2,10}$/im,
                    message:
                      "This field must be a valid phone number. Example: +3163633634",
                  },
                ]}
              >
                <Input
                  defaultValue={data?.value}
                  value={data?.value}
                  placeholder={data?.label}
                  onChange={(e) => {
                    data.value = e.target.value;
                  }}
                />
              </Form.Item>
            </Col>
          </Row>
        );
        break;
      case QuestionaireType.Name:
        renderEle = (
          <Row className="d-flex">
            <Col span={24}>
              <Form.Item name={itemName}>
                <Input className="w-full" placeholder={data?.label} />
              </Form.Item>
            </Col>
          </Row>
        );
        break;
      case QuestionaireType.Time:
        renderEle = (
          <Row>
            <Col span={24}>
              <div className="datetime-item">
                <img src="/images/time.png" alt="" />
                <Form.Item name={itemName}>
                  <TimeInput
                    name={data?.label}
                    value={time}
                    onChange={(time) => {
                      onChange(time);
                    }}
                  />
                </Form.Item>
              </div>
            </Col>
          </Row>
        );
        break;
      case QuestionaireType.Project:
        renderEle = (
          <Row>
            <Col span={24}>
              <Form.Item name={itemName}>
                <Select
                  showSearch
                  className="w-full"
                  placeholder={data?.label}
                  onChange={(value) => {
                    onProjectChange(value);
                  }}
                  filterOption={(input, option) =>
                    (option!.children as unknown as string)
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                >
                  {projects?.projects?.map((project, index) => (
                    <Option key={index} value={project.id}>
                      {project.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        );
        break;

      case QuestionaireType.Search:
        renderEle = (
          <Row>
            <Col span={24}>
              <Form.Item name={itemName}>
                {data?.isMulti ? (
                  <Select
                    showSearch
                    className="w-full"
                    placeholder={data?.label}
                    mode={"multiple"}
                    value={data?.value}
                    defaultValue={data?.value}
                    onChange={(value) => {
                      onProjectChange(value);
                    }}
                  >
                    {data?.options?.map((option, index) => (
                      <Option key={index} value={option?._id}>
                        {option?.name}
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <Select
                    showSearch
                    className="w-full"
                    value={data?.value}
                    defaultValue={data?.value}
                    placeholder={data?.label}
                    onChange={(value) => {
                      onChange(value);
                    }}
                  >
                    {data?.options?.map((option, index) => (
                      <Option key={index} value={option?._id}>
                        {option?.name}
                      </Option>
                    ))}
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
        );
        break;

      default:
        renderEle = "";
    }
    return renderEle;
  };

  const onChangeBasicBio = (rowIndex: number, colIndex: number, value: any) => {
    const tempBio = [...selectBio.current.basicBio];

    tempBio[rowIndex].Cols[colIndex].value = value;
    selectBio.current = {
      basicBio: tempBio,
      extendedBio: selectBio.current.extendedBio,
    };
  };
  const onChangeExtendedBio = (
    rowIndex: number,
    colIndex: number,
    value: any
  ) => {
    const tempBio = [...selectBio.current.extendedBio];

    tempBio[rowIndex].Cols[colIndex].value = value;

    selectBio.current = {
      basicBio: selectBio.current.basicBio,
      extendedBio: tempBio,
    };
  };

  const onApproveHandler = () => {
    const queryId = Object.keys(bio?.metadata?.bulk)[0];

    let userBasicBioData: any = {};

    selectBio.current.basicBio.map((field: any) => {
      field.Cols.map((col: any) => {
        userBasicBioData[col?.name] = col?.value;
      });
    });

    const { email, phone } = userBasicBioData;

    let verificationChannelsIds = [];
    if (email) {
      verificationChannelsIds.push({ email: email });
    }
    if (phone) {
      verificationChannelsIds.push({ phone: phone });
    }

    const updatedUserData: any = [
      {
        op: "add",
        path: `/persistent/static/metadata/bulk/${queryId}/header/isAdminApproved`,
        value: true,
      },
      {
        op: "add",
        path: `/persistent/static/metadata/bulk/${queryId}/header/addAuthRequest/userIds`,
        value: [{ rootUserId: bioUrlParams.userId }],
      },
      {
        op: "add",
        path: `/persistent/static/metadata/bulk/${queryId}/header/addAuthRequest/newAuthTypeParam/param/verificationChannels`,
        value: verificationChannelsIds,
      },
    ];

    socket.publishToServiceIdSurvey(
      SocketTopics.SurveyTopics,
      UserTopics.UpdateUser,
      updateUserRequestPayloadV2(bioUrlParams.userId, updatedUserData),
      ExtendedBioTopics.UpdateUserBio,
      bioUrlParams.cudbServiceId
    );

    socket.subscribeToSurvey(
      SocketTopics.SurveyTopics,
      ExtendedBioTopics.UpdateUserBio,
      (data) => {
        setSearching(false);
        onSubmitHandler({});
        pushNotification(
          "User Approved Successfully",
          "successs",
          "TOP_CENTER",
          1000
        );
      }
    );
  };

  const onSubmitHandler = (values: any) => {
    let updatedUserData = [];

    if (bioUrlParams?.type !== ModalType.Vehicle) {
      let userExtendedBioData = {};
      let userBasicBioData: any = {};

      selectBio.current.extendedBio.map((field: any) => {
        field.Cols.map((col: any) => {
          userExtendedBioData[col?.name] = col?.value;
        });
      });
      selectBio.current.basicBio.map((field: any) => {
        field.Cols.map((col: any) => {
          userBasicBioData[col?.name] = col?.value;
        });
      });

      const { email, customId, phone, beamIds, roleId, ...userBasicBio } =
        userBasicBioData;

      const status =
        bioUrlParams?.role === "admin" ? "adminEdited" : "userEdited";
      let identifiers = {};
      let basicBio = {};
      let extendedBio = {};

      let basicIdentifires: any = {
        email,
        customId,
        phone,
      };

      const tempData: any = Object.values(bio?.metadata?.bulk);

      const { fields } = tempData[0];

      Object.keys(userBasicBio).map((el: any) => {
        if (el === "location") {
          if (userBasicBio?.location) {
            basicBio = {
              ...basicBio,
              [`${el}-lat`]: {
                ...fields[`${el}-lat`],
                value: userBasicBio?.location
                  ? userBasicBio?.location?.coordinates.lat
                  : fields[`${el}-lat`]?.value,
              },
              [`${el}-long`]: {
                ...fields[`${el}-long`],
                value: userBasicBio?.location
                  ? userBasicBio?.location?.coordinates.long
                  : fields[`${el}-long`]?.value,
              },
              attributes: {
                value: userBasicBio?.location?.attributes,
                identifier: null,
                status: "ok",
                reason: "",
                ref: `/persistent/static/live/profile/location/attributes`,
                approved: false,
              },
            };
          }
        } else {
          basicBio = {
            ...basicBio,
            [el]: {
              ...fields[el],
              value: userBasicBio[el],
            },
          };
        }
      });

      basicBio = {
        ...basicBio,
        roleId: {
          ...fields["roleId"],
          value: roleId,
        },
      };

      basicBio = {
        ...basicBio,
        beamIds: {
          ...fields["beamIds"],
          value: beamIds,
        },
      };

      Object.keys(userExtendedBioData).map((el: any) => {
        extendedBio = {
          ...extendedBio,
          [el]: {
            ...fields[el],
            value: userExtendedBioData[el],
          },
        };
      });

      Object.keys(basicIdentifires).forEach((el: any) => {
        identifiers = {
          ...identifiers,
          [el]: {
            ...fields[el],
            value: basicIdentifires[el],
          },
        };
      });

      var queryId =
        Object.keys(bio?.metadata?.bulk)[0] ||
        Math.floor(1000 + Math.random() * 9000);

      updatedUserData = [
        {
          op: "add",
          path: `/persistent/static/metadata/bulk/${queryId}/fields`,
          value: {
            ...fields,
            ...identifiers,
            ...basicBio,
            ...extendedBio,
          },
        },
        {
          op: "add",
          path: `/persistent/static/metadata/bulk/${queryId}/header/editingStatus`,
          value: status,
        },
      ];
    } else {
      let userExtendedBioData = {};

      selectBio.current.extendedBio.map((field: any) => {
        field.Cols.map((col: any) => {
          userExtendedBioData[col?.name] = col?.value;
        });
      });

      updatedUserData = [
        {
          op: "add",
          path: `/persistent/static/${bioUrlParams.cudbServiceId}/extendedBio`,
          value: {
            ...userExtendedBioData,
          },
        },
      ];
    }

    socket.publishToServiceIdSurvey(
      SocketTopics.SurveyTopics,
      UserTopics.UpdateUser,
      updateUserRequestPayloadV2(bioUrlParams.userId, updatedUserData),
      ExtendedBioTopics.UpdateUserBio,
      bioUrlParams.cudbServiceId
    );

    socket.subscribeToSurvey(
      SocketTopics.SurveyTopics,
      ExtendedBioTopics.UpdateUserBio,
      (data) => {
        setSearching(false);
        pushNotification("Bio Updated.", "successs", "TOP_CENTER", 1000);
      }
    );

    setError(undefined);
  };

  useEffect(() => {
    if (bioUrlParams?.type !== ModalType.Vehicle) {
      if (Object.keys(bio).length && rolesList.length) {
        setUserRoles([...rolesList]);

        const tempData: any = Object.values(bio?.metadata?.bulk);

        // role List with extended Bios
        const currentRole = rolesList.find(
          (role: any) => role?._id === tempData[0]?.fields?.roleId?.value
        );

        let liveUserBio = {};
        let tempExtendedBio = [];
        let liveUserExtendedBio = {};

        if (tempData?.length) {
          const userTempBulk = tempData[0]?.fields;
          let userBio: any = {};
          Object.keys(userTempBulk).map((el: any) => {
            userBio = {
              ...userBio,
              [el]: userTempBulk[el]?.value,
            };
          });

          const {
            email,
            phone,
            customId,
            roleId,
            beamIds,
            gender,
            firstName,
            middleName,
            lastName,
            location,
            ...userExtendedBio
          } = userBio;

          const beamId = Array.isArray(beamIds) ? beamIds[0] : beamIds;
          const userLocation = {
            coordinates: {
              lat: userExtendedBio["loaction-lat"] || 0,
              long: userExtendedBio["loaction-long"] || 0,
            },
            attributes: userExtendedBio?.attributes || {
              address: "",
              zip: "",
              stAddressOne: "",
              stAddressTwo: "",
              city: "",
              state: "",
              country: "",
            },
          };

          liveUserBio = {
            email,
            phone,
            customId,
            roleId,
            beamIds: beamId,
            gender,
            firstName,
            middleName,
            lastName,
            location: userLocation,
          };

          liveUserExtendedBio = {
            ...userExtendedBio,
          };
        } else {
          liveUserBio = {
            email: bio?.live.alternativeIds.email,
            phone: bio?.live.alternativeIds.phone,
            customId: bio?.live.alternativeIds.customId,
            roleId: bio?.admin?.profile?.roleId,
            beamIds: Array.isArray(bio?.live?.beamIds[0])
              ? bio?.live?.beamIds[0]
              : bio?.live?.beamIds,
            ...bio?.live.profile,
          };

          liveUserExtendedBio = {
            // TODO: Hard code for now
            ...bio[bioUrlParams.cudbServiceId]?.extendedBio,
          };
        }

        nine11Form.setFieldsValue({
          undefined: {
            ...liveUserBio,
            ...liveUserExtendedBio,
          },
        });

        if (currentRole) {
          tempExtendedBio = currentRole.extendedBio.map((col) => {
            return {
              Cols: [
                {
                  ...col,
                  ColSize: 24,
                  value: liveUserExtendedBio[col.name] || col.value,
                },
              ],
            };
          });
        }

        const tempBasicBio = Bio.map((row) => {
          return {
            Cols: row.Cols.map((col) => {
              return {
                ...col,
                value: liveUserBio[col.name] || col.value,
                options:
                  col.name === "roleId"
                    ? rolesList.map((role: any) => {
                        return { _id: role._id, name: role.name };
                      })
                    : col.options,
              };
            }),
          };
        });

        selectBio.current = {
          basicBio: [...tempBasicBio],
          extendedBio: [...tempExtendedBio],
        };
      }
    } else if (bioUrlParams?.type === ModalType.Vehicle) {
      let liveUserExtendedBio = {
        // TODO: Hard code for now
        ...bio[bioUrlParams.cudbServiceId]?.extendedBio,
      };

      nine11Form.setFieldsValue({
        undefined: {
          ...liveUserExtendedBio,
        },
      });

      let tempExtendedBio = survey.questions.map((col) => {
        return {
          Cols: [
            {
              ...col,
              ColSize: 24,
              value: liveUserExtendedBio[col.name] || col.value,
            },
          ],
        };
      });

      selectBio.current = {
        basicBio: [],
        extendedBio: [...tempExtendedBio],
      };
    }
  }, [rolesList, bio, bioUrlParams, survey]);

  useEffect(() => {
    const urlLink = getParameterByName("token");
    dispatch(SET_URL_PARAMS({ payload: urlLink }));
  }, []);

  useEffect(() => {
    if (Object.keys(urlParams)?.length) {
      setBioUrlParams(urlParams);
    }
  }, [urlParams]);

  useEffect(() => {
    if (socket.client && Object.keys(bioUrlParams)?.length) {
      if (bioUrlParams?.type === ModalType.Vehicle) {
        socket.publishToServiceIdSurvey(
          SocketTopics.SurveyTopics,
          UserTopics.SearchInUser,
          getUserRequestPayload(
            bioUrlParams.adminId,
            "$",
            getVehicleExtendedBioPath()
          ),
          ExtendedBioTopics.GetVehicleBio,
          bioUrlParams.cudbServiceId
        );

        socket.subscribeToSurvey(
          SocketTopics.SurveyTopics,
          ExtendedBioTopics.GetVehicleBio,
          () => {}
        );
      } else {
        socket.publishToServiceIdSurvey(
          SocketTopics.SurveyTopics,
          UserTopics.SearchInUser,
          getUserRequestPayload(bioUrlParams.adminId, "$", getUserRolesPath()),
          BioTopics.GetRoleList,
          bioUrlParams.cudbServiceId
        );

        socket.subscribeToSurvey(
          SocketTopics.SurveyTopics,
          BioTopics.GetRoleList
        );
      }

      socket.publishToServiceIdSurvey(
        SocketTopics.SurveyTopics,
        UserTopics.SearchInUser,
        getUserRequestPayload(bioUrlParams.userId, "$", getUserPath()),
        BioTopics.GetBio,
        bioUrlParams.cudbServiceId
      );

      socket.subscribeToSurvey(SocketTopics.SurveyTopics, BioTopics.GetBio);
    }
  }, [socket.client, bioUrlParams]);

  const onProjectChange = (projectId) => {
    dispatch({ type: SET_CURRENT_PROJECT, payload: projectId });
  };

  return (
    <div className="main-column ride-dispatch-panel mobile-responsive mr-4">
      <div className="main-content">
        <Form
          className="auth-form"
          name="register-form"
          //    initialValues={JSON.parse(localStorage.getItem("form") || "{}")}
          id="register-form"
          layout="vertical"
          form={nine11Form}
          onFinish={onSubmitHandler}
          requiredMark={false}
          onValuesChange={(value, allValues) => {}}
        >
          {bioUrlParams?.type && <div className="main-header">
            <div className="d-flex">
              <h3 className="ml-3">
                {bioUrlParams.type === ModalType.Vehicle
                  ? "Vehicle Bio"
                  : "User Bio"}
              </h3>
            </div>
            <div className="d-flex">
              <ReactSVG
                src="/images/close-icon.svg"
                className="close-icon"
                onClick={() => {
                  setTimeout(() => {
                    localStorage.removeItem("form");
                    localStorage.removeItem("form");
                    dispatch({ type: SET_SUBMITTED, payload: false });
                    nine11Form.resetFields();
                    setScreens({
                      ...screens,
                      map: false,
                    });
                    const query = new URLSearchParams(search);
                    query.delete("pageId");
                    history.replace({
                      search: query.toString(),
                    });
                  });
                }}
              />
            </div>
          </div>
          }
          <div className="main-cards">
            <Collapse
              defaultActiveKey={JSON.parse(localStorage.getItem("active"))}
              bordered={false}
              className="simple-collapse"
              onChange={(active) => {
                localStorage.setItem("active", JSON.stringify(active));
              }}
            >
              {selectBio.current.basicBio?.length && bioUrlParams?.type !== ModalType.Vehicle && (
                <Panel
                  header={
                    <div className="d-flex">
                      <ReactSVG src="/images/account-icon.svg" />
                      <h5 className="ml-3">Basic Bio</h5>
                    </div>
                  }
                  key="basicBio"
                >
                  <div className="sub-cards-2">
                    {selectBio.current.basicBio.map((row, rowIndex) => {
                      return (
                        <Row className="mt-3 mobile-row" key={rowIndex}>
                          {row.Cols.map((col, colIndex) => {
                            return (
                              <Col
                                className="pl-2"
                                key={`${colIndex}-cols`}
                                span={col.ColSize}
                                xs={24}
                                sm={col.ColSize}
                              >
                                <RenderFields
                                  data={col}
                                  onChange={(value) => {
                                    onChangeBasicBio(rowIndex, colIndex, value);
                                  }}
                                />{" "}
                              </Col>
                            );
                          })}
                        </Row>
                      );
                    })}
                  </div>
                </Panel>
              )}
             { selectBio.current.extendedBio?.length && <Panel
                header={
                  <div className="d-flex">
                    <ReactSVG src="/images/account-icon.svg" />
                    <h5 className="ml-3">Extended Bio</h5>
                  </div>
                }
                key="extendedBio"
              >
                <div className="sub-cards-2">
                  {selectBio.current.extendedBio.map((row, rowIndex) => {
                    return (
                      <Row className="mt-3 mobile-row" key={rowIndex}>
                        {row.Cols.map((col, colIndex) => {
                          return (
                            <Col
                              className="pl-2"
                              key={`${colIndex}-cols`}
                              span={col.ColSize}
                              xs={24}
                              sm={col.ColSize}
                            >
                              <RenderFields
                                data={col}
                                onChange={(value) => {
                                  onChangeExtendedBio(
                                    rowIndex,
                                    colIndex,
                                    value
                                  );
                                }}
                              />{" "}
                            </Col>
                          );
                        })}
                      </Row>
                    );
                  })}
                </div>
              </Panel>
           }
            </Collapse>
          </div>

          {error && (
            <Form.Item>
              <p className="error">{error}</p>
            </Form.Item>
          )}
          {bioUrlParams?.role === "admin" && (
            <Row className="action-grp mt-4">
              <Col span={8} className="pr-2" xs={24} sm={8}>
                <Form.Item>
                  <Button
                    className="beam-btn yellow-btn cover w-full"
                    //  htmlType="submit"
                    loading={searching}
                    onClick={onSubmitHandler}
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Col>
              {bioUrlParams.type !== ModalType.Vehicle && (
                <Col span={8} className="pr-2" xs={24} sm={8}>
                  <Form.Item>
                    <Button
                      className="beam-btn green-btn cover w-full"
                      loading={searching}
                      onClick={onApproveHandler}
                    >
                      Approve
                    </Button>
                  </Form.Item>
                </Col>
              )}
            </Row>
          )}

          {bioUrlParams?.role === "user" && (
            <Row className="action-grp mt-3 ">
              <Col span={8} className="pr-2" xs={24} sm={8}>
                <Form.Item>
                  <Button
                    className="beam-btn yellow-btn cover w-full"
                    //  htmlType="submit"
                    loading={searching}
                    onClick={onSubmitHandler}
                  >
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          )}
        </Form>
      </div>
    </div>
  );
};

export default DispatchPanel;
